import { render, staticRenderFns } from "./CampaignsFiltersSelected.vue?vue&type=template&id=22cd1956"
import script from "./CampaignsFiltersSelected.vue?vue&type=script&lang=ts"
export * from "./CampaignsFiltersSelected.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports